import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import { Observable } from 'rxjs';
import { UserConfig } from './user.config';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private httpService: HttpService) {
     // This is intentional
  }

  getAllUserList(key?: string): Observable<any> {
    return this.httpService.get(`${UserConfig.EndPoint.User.getAllUserList}/${key}`);
  }
  getAllUserOrgList(orgid: any) {
    return this.httpService.get(UserConfig.EndPoint.User.getAllUserOrgList + orgid);
  }
  getAllUserActiveInactive(key?: string): Observable<any> {
    const endPoint = key
      ? `${UserConfig.EndPoint.User.getAllUserList}/${key}`
      : UserConfig.EndPoint.User.getAllUserActiveInactive;
    return this.httpService.get(endPoint);
  }
  saveUser(data: any) {
    return this.httpService.post(UserConfig.EndPoint.User.createUser, data);
  }
  updateUser(data: any, userid: string) {
    return this.httpService.put(`${UserConfig.EndPoint.User.getAllUserList}/${userid}`, data);
  }
  deleteUser(id?: string) {
    return this.httpService.delete(`${UserConfig.EndPoint.User.getAllUserList}/${id}`);
  }
  activateUser(data: any) {
    return this.httpService.post(UserConfig.EndPoint.User.activateUser, data);
  }
  getProviderList() {
    return this.httpService.get(UserConfig.EndPoint.Provider.getProviderList);
  }
  searchProviderList(data: any) {
    return this.httpService.post(UserConfig.EndPoint.Provider.searchProviderList, data);
  }
  addProviderUser(data: any) {
    return this.httpService.post(UserConfig.EndPoint.Provider.addProviderUser, data);
  }
  addUserRole(data: any) {
    return this.httpService.post(UserConfig.EndPoint.User.userRole, data);
  }
  getTeamsByManagementGroup(managementgroupid: number) {
    return this.httpService.get(`${UserConfig.EndPoint.User.managementgroup}/${managementgroupid}`);
  }
}
